export const getLastInvite = (booking) =>
  booking.garageInvites.sort((a, b) => (a.creationDateTime > b.creationDateTime ? -1 : 1))[0];

export const isLastBookingInviteDraft = (booking) => {
  if (typeof booking.garageInvites === 'undefined' || booking.garageInvites.length === 0) return false;
  const lastInvite = getLastInvite(booking);
  return lastInvite && lastInvite.status === 'draft';
};

export const getRescheduledInvites = (booking) => {
  if (typeof booking.garageInvites === 'undefined' || booking.garageInvites.length === 0) return [];
  return booking.garageInvites.filter(
    (invite) =>
      invite.proposedChanges &&
      invite.proposedChanges.length > 0 &&
      invite.proposedChanges.find((pc) => pc.type === 'collection-time' || pc.type === 'delivery-time')
  );
};

export const bookingHasReschedules = (booking) => getRescheduledInvites(booking).length > 0;

export const bookingWithNoInvite = (booking) => !booking.garageInvites || booking.garageInvites.length === 0;

export const hasDraftInvite = (booking) =>
  (booking?.garageInvites || []).filter((i) => i.status === 'draft').length > 0;

export const hasNoPendingInvite = (booking) =>
  (booking?.garageInvites || []).filter((i) => i.status === 'pending').length === 0;
